import { Container, Row } from "reactstrap";
import TotalStudents from "../Education/TotalStudents/TotalStudents";

const ContainerDefault = () => {
  return (
    <Container fluid className="default-dashboard">
      <Row>
        <TotalStudents />
      </Row>
    </Container>
  );
};

export default ContainerDefault;

